import React, { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import axiosInstance from "../../api/axiosInstance";
import EngineeringOutlinedIcon from '@mui/icons-material/EngineeringOutlined';
import moment from 'moment';
import "./operator.scss"

const Operator = () => {
    const [events, setEvents] = useState([]);
    const [isLoading, setLoading] = useState(true);

    const fetchData = useCallback(async () => {
        try {
            const [eventsRes] = await Promise.all([
                axiosInstance.get(`operators/events`)
            ]);
            setEvents(eventsRes.data);
            setLoading(false);
        } catch (err) {
            console.error(err);
        }
    }, []);

    useEffect(() => {
        fetchData();
    }, [fetchData]);

    return isLoading ? (<div className="loading" />) : (
        <div className="operator">
            <Helmet>
                <title>Fahrtenplan</title>
            </Helmet>
            <div className="container">
                <div class="group active">
                    <div className="top">
                        <span>{moment(events[0].startDate).format("DD.MM - dddd")}</span>
                    </div>
                    <div className="list">
                        {events.map((event) => (
                            <Link key={event.id} className={event.done ? "item done" : "item"} to={`/operator/event/${event.id}`}>
                                <span className="desc">{event.description || "Auftrag"} {event.customer}</span>
                                <span className="customer">{event.startTime} - {event.endTime}</span>
                                {(event.workTime !== null && !event.done) && <span className="inWork"><EngineeringOutlinedIcon /></span>}
                            </Link>
                        ))}
                    </div>
                </div>
                <div class="group">
                    <div className="top">
                        <span>{events.startDate && moment(events[0].startDate).format("DD.MM - dddd")}</span>
                    </div>
                </div>
            </div>
        </div>
    )
};

export default Operator